import React from 'react'

import StructuredTextReport from '@/components/models/report/structured-text-report/structured-text-report'

import * as style from './bullets-slide.module.scss'

const BulletsSlide = ({ slide, customIndex }) => {
  return (
    <>
      <div className="col-12">
        {slide.isContinued ? null : (
          <span className={`tag`}>Insight 0{customIndex}</span>
        )}
        <h3 className={`color-base-1000 h300 m-0 ${style.title}`}>
          {slide.title}
        </h3>
      </div>
      <div className="col-12 col-lg-5">
        <StructuredTextReport content={slide.preContent} />
      </div>
      <div className="col-12 col-lg-5 offset-lg-2">
        <StructuredTextReport content={slide.content} />
      </div>
    </>
  )
}

export default BulletsSlide
